import { apiConfig } from '../config';
import { request, waitUntilStatusCompleted, withErrorHandling, withRetry } from './SetDirection';

export async function setServiceState(params, options = {}) {
  const checkStatus = await callSetServiceState(params, options);

  return waitUntilStatusCompleted(checkStatus, options);
}

export function callSetServiceState(params, options = {}) {
  const { deviceId, rfPath, serviceRequest } = params;
  const url = apiConfig.cmServiceSetServiceState(deviceId);
  const body = JSON.stringify({
    'rf-path': rfPath,
    'service-request': serviceRequest
  });

  return withErrorHandling(withRetry(request, options.retry))(url, {
    method: 'POST',
    body
  });
}
